import lightPlateBackground from '../../list-plate-background/light';

const light = (params) => lightPlateBackground(params);

export default light;
